import { container } from '@/core/di';
import { UserSessionApi } from './UserSessionApi';

export const userSessionApi: () => UserSessionApi = () => container.resolve(UserSessionApi);
